export default {
  title: "Status Pre Contacto"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5012: { text: "Ocurrió un error en el catálogo de Status Pre Contacto" }
    , WS5012: { text: "Ocurrió un error en el catálogo de Status Pre Contacto" }
    , JS5012: { text: "Ocurrió un error en el catálogo de Status Pre Contacto" }
    , CR5012: { text: "Ocurrió un error en el catálogo de Status Pre Contacto" }
    , UK_StatusPreContacto: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/statusPreContacto.js